import { useState } from 'react';
const DEFAULT_PREFIX = '$component$';
const uniqueId = {};
const generateUniqueId = (prefix) => {
    if (!uniqueId[prefix]) {
        uniqueId[prefix] = 0;
    }
    return uniqueId[prefix]++;
};
export const useId = (prefix) => {
    const [id] = useState(() => generateUniqueId(prefix || DEFAULT_PREFIX));
    return `${prefix}${id}`;
};
//# sourceMappingURL=useId.js.map